import tw, { styled } from 'twin.macro';

export const Wrapper = styled.div`
  ${tw`flex flex-col gap-8 mt-6 `}
`;

export const InventoryWrapper = styled.div`
  ${tw`flex gap-6 flex-wrap`};

  &.list {
    flex-direction: column;
  }
`;

export const GridProduct = styled.div`
  ${tw`flex flex-col`};
  border: 0.5px solid #aaaaaa;
  height: max-content;
  border-radius: 5px;
  flex-grow: 0;

  flex-basis: ${({ isMobileBuilderPreview }) => isMobileBuilderPreview ? '100%' : '250px'};
  width: ${({ isMobileBuilderPreview }) => isMobileBuilderPreview ? '100%' : '250px'};

  @media (max-width: 1024px) {
    flex-basis: ${({ isMobileBuilderPreview }) => isMobileBuilderPreview ? '100%' : '226px'};
    width:  ${({ isMobileBuilderPreview }) => isMobileBuilderPreview ? '100%' : '226px'};
  }

  @media (max-width: 512px) {
    flex-basis: 100%;
    width: 100%;
  }
`;

export const GridImageWrapper = styled.div`
  ${tw`flex justify-center p-4`};
  border-bottom: 0.5px solid #aaaaaa;
  background: transparent;
  position: relative;
  height: 220px;
  width: 100%;
`;

export const Image = styled.img`
  object-fit: contain;
  // border-radius: 15px;
  height: 100%;
  width: 100%;
`;

export const GridDetail = styled.div`
  ${tw`flex flex-col justify-between gap-4 p-4 relative`};
  height: 230px;
  clear: left;
  max-height: 250px;

  & .top {
    ${tw`flex flex-col gap-4`};
  }

  & .title {
    ${tw`w-full`};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    span {
      font-family: var(--formFontType, Circular Std) !important;
      font-size: var(--formFontSize, 14px);
      font-weight: 500;
      color: #3f3e3e;
    }
  }

  & .description {
    ${tw`w-full`};

    p {
      font-family: var(--formFontType, Circular Std) !important;
      ${tw`overflow-ellipsis overflow-hidden`};
      font-size: var(--formFontSize, 12px);
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      display: -webkit-box;
      font-weight: 300;
      color: #3f3e3e;
    }
  }

  & .price {
    ${tw`flex justify-end w-full`}
    span {
      font-family: var(--formFontType, Circular Std) !important;
      font-size: var(--formFontSize, 16px);
      font-weight: 550;
      color: #28879d;
    }
  }
`;

export const ActionWrapper = styled.div`
  ${tw`flex flex-wrap gap-4 w-full`};

  &.list {
    ${tw`justify-between`};

    & .selectors {
      & .dropdown, .flex_col {
        ${tw`gap-3 items-center`};
      }
  
      &.sm span.label {
        ${tw`hidden`}
      }

      span.label {
        @media (max-width: 720px) {
          ${tw`hidden`}
        }
      }
    }
  }

  &:not(.list) {
    & .selectors {
      & .dropdown, .flex_col {
        ${tw`flex-col`};
      }
    }
  }

  & .selectors {
    ${tw`flex flex-wrap items-center gap-3`};

    & button {
      ${tw`bg-fplsBlue text-white text-sm outline-none border-none w-32 rounded-sm p-2 px-4 cursor-pointer`};
    }

    & .dropdown {
      ${tw`flex`};
      
      & .ui.selection.dropdown {
        border: 0.5px solid #c4c4c4 !important;
        min-height: 0px !important;
        border-radius: 5px;
        padding: 8px;
        width: 80px;
  
        & .text {
          font-family: var(--formFontType, Inter) !important;
          font-size: var(--formFontSize, 13px);
          font-weight: 400;
          
          &.default {
            ${tw`w-full overflow-hidden whitespace-nowrap overflow-ellipsis`};
          }
        }
  
        // Label indicators on multi select modal
        & .item .text {
          color: #5b5656;
          font-weight: 450;
          font-size: 14px;
        }
  
        & .item .label {
          transform: translateY(-50%);
          padding: 0 !important;
          position: absolute;
          border-radius: 50%;
          left: 5px;
          top: 50%;
        }
  
        & .label {
          background: #f0f5ff;
          border-radius: 2px;
          font-weight: 100;
          color: #4f4f4f;
        }
  
        & > .delete.icon, > .dropdown.icon, > .search.icon {
          padding-right: 5px;
          line-height: 90%;
          min-width: auto;
          height: 100%;
        }
      }
    }

    & .flex_col {
      ${tw`flex`};

      & .btn-left {
        ${tw`flex`};
        border: 0.2px solid #c4c4c4;
        width: max-content;
        border-radius: 5px;
        height: 32px;
    
        & button {
          justify-content: center;
          background: transparent;
          align-items: center;
          cursor: pointer;
          color: #a4a3a3;
          display: flex;
          border: none;
          width: 27px;

          :disabled {
            cursor: not-allowed;
          }
        }
    
        & input {
          font-family: var(--formFontType, Circular Std) !important;
          font-size: var(--formFontSize, 10px);
          font-weight: 500;
          color: #4f4f4f;
          height: 100%;
          border: none;
          width: 27px;

          :focus {
            border-bottom: 0.5px solid #00afbf;
            outline: none;
          }

          :disabled {
            cursor: not-allowed;
            color: #a4a3a3;
          }
        }
    
        & input[type='number']::-webkit-inner-spin-button,
        & input[type='number']::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
    
        & input[type='number'] {
          -moz-appearance: textfield;
          text-align: center;
        }
      }
    }

    & span.label {
      ${tw`overflow-hidden whitespace-nowrap overflow-ellipsis`};
      font-family: var(--formFontType, Circular Std) !important;
      font-size: var(--formFontSize, 12px);
      font-weight: 400;
      max-width: 80px;
      color: #888888;
    }
  }

  & .price {
    ${tw`flex justify-end items-center`}

    span {
      font-family: var(--formFontType, Circular Std) !important;
      font-size: var(--formFontSize, 16px);
      font-weight: 550;
      color: #28879d;
    }
  }
`;

export const List = styled.div`
  ${tw`w-full gap-0 p-3 flex pb-2 relative`}
  border: 0.5px solid #aaaaaa;
  border-radius: 5px;

  .content {
    ${tw`flex gap-6 relative`};
    width: calc(100% - 30px);
    
    &.sm {
      ${tw`block pt-1 pb-2`};

      .error {
        ${tw`mb-3`};
      }
    }

    & .container {
      ${tw`w-full flex gap-4`};

      &.sm {
        ${tw`gap-3 mb-3`};
      }

      & .image {
        height: 120px;
        width: 160px;

        &.sm {
          width: 100px;
          height: 85px;
        }

        &.xs {
          height: 82px;
          width: 80px;
        }

        @media (max-width: 512px) {
          width: 100px !important;
          height: 85px !important;
        }

        @media (max-width: 375px) {
          height: 82px !important;
          width: 80px !important;
        }
      }

      .detail {
        ${tw`flex flex-col gap-4 pb-2`};
        width: calc(100% - 160px);

        &.sm {
          width: calc(100% - 100px);
        }

        &.xs {
          width: calc(100% - 80px);
        }

        @media (max-width: 512px) {
          width: calc(100% - 100px) !important;

          ${tw`gap-1`};
        }

        @media (max-width: 375px) {
          width: calc(100% - 80px) !important;
        }

        & .title {
          ${tw`w-full`}
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          flex:1;

          span {
            font-family: var(--formFontType, Circular Std) !important;
            font-size: var(--formFontSize, 14px);
            font-weight: 600;
            color: #3f3e3e;
          }
        }

        & .description {
          ${tw`w-full`}
          flex: 1;

          p {
            font-family: var(--formFontType, Circular Std) !important;
            ${tw`overflow-ellipsis overflow-hidden`};
            font-size: var(--formFontSize, 12px);
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            display: -webkit-box;
            font-weight: 400;
            color: #3f3e3e;
          }
        }
      }
    }
  }
`;

export const Total = styled.div`
  ${tw`flex w-full justify-end gap-12`};
  font-weight: 550;

  & .total {
    font-family: var(--formFontType, Circular Std) !important;
    font-size: var(--formFontSize, 14px);
    color: #3f3e3e;
  }

  & .sum span {
    font-family: var(--formFontType, Circular Std) !important;
    font-size: var(--formFontSize, 16px);
    color: #28879d;
  }
`;

export const OutOfStockWrapper = styled.div`
  ${tw`absolute left-2 top-4`};
  width: max-content;
`;
